(function (root) {
  'use strict';
  const validId = (id) => /^[1-9]\d*$/.test(String(id));
  const validPrice = (price) => Number.isSafeInteger(price) && price >= 0;
  function selection(catalog, offer) {
    if (!catalog?.offers || !Object.hasOwn(catalog.offers, offer) || !catalog.offers[offer]) throw new Error('Missing Shopify product');
    return catalog.offers[offer];
  }
  function sellingPlan(variant, planId) {
    const allocation = variant.plans?.find((plan) => String(plan.id) === String(planId));
    if (!allocation || !validId(allocation.id) || !validPrice(allocation.price)
      || allocation.price !== allocation.perDeliveryPrice || allocation.price !== allocation.checkoutCharge
      || allocation.remainingBalance !== 0 || !Array.isArray(allocation.adjustments)
      || allocation.adjustments.some((price) => price !== allocation.price)) throw new Error('Shopify subscription allocation is unavailable');
    return allocation;
  }
  function quote(offer, mode = 'one_time', quantity = 1, catalog, planId) {
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Invalid quantity');
    if (!['one_time', 'replenishment'].includes(mode)) throw new Error('Unknown purchase option');
    const variant = selection(catalog, offer);
    if (!validPrice(variant.price)) throw new Error('Missing Shopify price');
    if (mode === 'one_time' && variant.requiresSellingPlan) throw new Error('This Shopify product requires a subscription');
    const allocation = mode === 'replenishment' ? sellingPlan(variant, planId) : null;
    const unitPrice = allocation ? allocation.price : variant.price;
    const compareAtPrice = !allocation && validPrice(variant.compareAtPrice) && variant.compareAtPrice > unitPrice ? variant.compareAtPrice : unitPrice;
    return { quantity, unitPrice, subtotal: compareAtPrice * quantity, total: unitPrice * quantity,
      discountPercent: compareAtPrice > unitPrice ? Math.round((compareAtPrice - unitPrice) * 100 / compareAtPrice) : 0 };
  }
  function cartItems(catalog, offer, mode = 'one_time', quantity = 1, planId) {
    quote(offer, mode, quantity, catalog, planId);
    const variant = selection(catalog, offer);
    if (catalog.enabled !== true || !/^[A-Z]{3}$/.test(catalog.currency || '')) throw new Error('Purchasing is not configured');
    if (!validId(variant.id) || variant.available !== true) throw new Error('Shopify product is unavailable');
    const item = { id: String(variant.id), quantity };
    if (mode === 'replenishment') item.selling_plan = String(sellingPlan(variant, planId).id);
    return [item];
  }
  const api = Object.freeze({ quote, cartItems });
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NelouraBundlePricing = api;
})(typeof window === 'undefined' ? {} : window);
